import { Poptip } from "@optimizely/axiom";
import React from "react";
import { VirtualTeammate } from "../SVGIcons/VirtualTeammate";
import classnames from "classnames";

export const AgentUserIndicator = ({ className = "", fill = "#0037ff" }: { className?: string; fill?: string }) => {
    const classes = classnames("agent-icon", className);
    return (
        <Poptip content="Virtual Teammate" position="top" isInline={true} className="" trigger="mouseenter">
            <span className={classes}>
                <VirtualTeammate fill={fill} />
            </span>
        </Poptip>
    );
};

AgentUserIndicator.displayName = "AgentUserIndicator";
